
import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import StudentRegistration from "@/components/StudentRegistration";
import PhoneOTPLogin from "@/components/PhoneOTPLogin";
import { Sparkles } from "lucide-react";

type ViewType = 'phone-login' | 'student-register';

const Login = () => {
  const [currentView, setCurrentView] = useState<ViewType>('phone-login');

  const renderCurrentView = () => {
    switch (currentView) {
      case 'student-register':
        return <StudentRegistration onBack={() => setCurrentView('phone-login')} />;
      default:
        return <PhoneOTPLogin onBack={() => setCurrentView('phone-login')} />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 flex items-center justify-center p-3 sm:p-4 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -inset-10 opacity-30">
          <div className="absolute top-1/4 left-1/4 w-48 h-48 sm:w-72 sm:h-72 lg:w-96 lg:h-96 bg-gradient-to-r from-indigo-400 to-purple-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
          <div className="absolute top-3/4 right-1/4 w-48 h-48 sm:w-72 sm:h-72 lg:w-96 lg:h-96 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-1000"></div>
          <div className="absolute bottom-1/4 left-1/3 w-48 h-48 sm:w-72 sm:h-72 lg:w-96 lg:h-96 bg-gradient-to-r from-pink-400 to-indigo-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-2000"></div>
        </div>
      </div>
      
      <div className="w-full max-w-md relative z-10">
        {/* Header */}
        <div className="text-center mb-6 sm:mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-full shadow-2xl mb-4">
            <span className="text-xl sm:text-2xl font-bold text-white">TS</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent mb-2">
            TattvaSphere
          </h1>
          <p className="text-gray-600 font-medium text-sm sm:text-base">Offline Education Classes</p>
        </div>

        {renderCurrentView()}

        {currentView === 'phone-login' && (
          <div className="mt-6">
            <Card className="backdrop-blur-sm bg-white/90 shadow-2xl border-0">
              <CardContent className="pt-6">
                <div className="text-center text-sm text-gray-600 mb-4">
                  Don't have an account?
                </div>
                <Button 
                  variant="outline" 
                  onClick={() => setCurrentView('student-register')}
                  className="w-full h-12 border-2 border-purple-200 hover:border-purple-300 hover:bg-purple-50 text-purple-700 font-medium rounded-xl transition-all duration-200 transform hover:scale-[1.02]"
                >
                  Register as Student
                </Button>
              </CardContent>
            </Card>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
